import { itwApi } from '../middlewares/api';
const getFilteredProjectDetail = async (query) => {
    const response = await itwApi.post('Project/filtered-prject-details', query);
    return response.data;
};
const createProject = async (data) => {
    const response = await itwApi.post('/Project', data);
    return response.data;
};
const updateProject = async (projectId, data) => {
    const response = await itwApi.put(`/Project/${projectId}`, data);
    return response.data;
};
const deleteProjectbyId = async (id) => {
    var response = await itwApi.delete(`Project/${id}`);
    return response.data;
};
export const ProjectApi = {
    getFilteredProjectDetail,
    createProject,
    updateProject,
    deleteProjectbyId
};
